<template>
<div>
  <com-header :compID="$route.params.id" activeKey="gywm"></com-header>
  <div class="about-view layout-router">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="企业介绍" name="qyjs"></el-tab-pane>
      <el-tab-pane label="资质证件" name="zzzj"></el-tab-pane>
      <el-tab-pane label="企业图册" name="qytc"></el-tab-pane>
      <el-tab-pane label="新闻动态" name="xwdt"></el-tab-pane>
    </el-tabs>
    <div class="about-content">
      <comp-intro v-if="activeName === 'qyjs'"></comp-intro>
      <certif-list v-if="activeName === 'zzzj'"></certif-list>
      <image-list v-if="activeName === 'qytc'"></image-list>
      <news-list v-if="activeName === 'xwdt'" @openNewDetail="openNewDetail"></news-list>
      <news-detail v-if="activeName === 'xwdtxq'" :newId="newId" @returnList="returnList"></news-detail>
    </div>
  </div>
</div>
</template>

<script>
import ComHeader from '@/views/company/header/index.vue';
import CompIntro from './compIntro.vue';
import CertifList from './certifList.vue';
import ImageList from './imageList.vue';
import NewsList from './news.vue';
import NewsDetail from './newsDetail.vue';

export default {
  data() {
    return {
      activeName: 'qyjs',
      newId: '',
    }
  },
  components: { ComHeader, CompIntro, CertifList, ImageList, NewsList, NewsDetail },
  methods: {
    handleClick(tab){
      this.activeName = tab.paneName;
    },
    returnList(){
      this.newId = '';
      this.activeName = 'xwdt';
    },
    openNewDetail(newId) {
      this.newId = newId;
      this.activeName = 'xwdtxq';
    }
  }
}
</script>

<style lang="less" scoped>
.about-view{
  min-height: calc(100vh - 189px - 32px);
  background: #FFFFFF;
  padding: 10px 40px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  /deep/ .el-tabs__nav-wrap::after{
    height: 0;
  }
  /deep/ .el-tabs__active-bar{
    background: linear-gradient(90deg, #0A89C5 0%, #995CB6 100%);
  }
  /deep/ .el-tabs{
    width: 350px;
    margin: 0 auto;
  }
}
</style>
